module.exports = __webpack_public_path__ + "static/media/logo-small.95427fd3.svg";